import { TooltipProvider } from "@/components/ui/tooltip";
import { LockOpen } from "lucide-react";
import {
  CanvasFloatingToolbarFrame,
  CanvasToolbarButton,
} from "../../components/toolbar";
import { useCanvasApi } from "../../context/CanvasContext";
import { CanvasFloatingToolbarPortal } from "./CanvasFloatingToolbarPortal";

interface CanvasUnlockToolbarProps {
  nodeIds: string[];
  positionAbsoluteX: number;
  positionAbsoluteY: number;
  width: number;
  topOffset?: number;
}

/**
 * What a locked selection shows in place of its toolbar: one Unlock button.
 * Callers mount it only when every selected node is locked and the viewer
 * can edit.
 */
export function CanvasUnlockToolbar({
  nodeIds,
  positionAbsoluteX,
  positionAbsoluteY,
  width,
  topOffset,
}: CanvasUnlockToolbarProps) {
  const { setNodesLocked } = useCanvasApi();

  return (
    <CanvasFloatingToolbarPortal
      positionAbsoluteX={positionAbsoluteX}
      positionAbsoluteY={positionAbsoluteY}
      width={width}
      topOffset={topOffset}
    >
      <TooltipProvider delayDuration={300}>
        <CanvasFloatingToolbarFrame onMouseDown={(e) => e.preventDefault()}>
          <CanvasToolbarButton
            label="Unlock"
            onClick={() => setNodesLocked(nodeIds, false)}
          >
            <LockOpen className="size-4" />
          </CanvasToolbarButton>
        </CanvasFloatingToolbarFrame>
      </TooltipProvider>
    </CanvasFloatingToolbarPortal>
  );
}
